<template>
  <div class="password-strength mt-2">
    <div class="strength-bar">
      <div
        v-for="i in 4"
        :key="i"
        class="strength-segment"
        :class="password.length > 0 && i <= segments ? `filled-${level}` : 'empty'"
      />
    </div>
    <span class="strength-label" :class="password.length > 0 ? `label-${level}` : ''" :style="{ visibility: password.length > 0 ? 'visible' : 'hidden' }">{{ label }}</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { calculatePasswordStrength } from '@/composables/passwordStrength'

const props = defineProps<{ password: string }>()

const score = computed(() => calculatePasswordStrength(props.password))

const segments = computed(() => {
    if (score.value >= 80) return 4
    if (score.value >= 50) return 3
    if (score.value >= 20) return 2
    return 1
})

const level = computed(() => ['weak', 'weak', 'fair', 'good', 'strong'][segments.value] as string)
const label = computed(() => ({ weak: 'Weak', fair: 'Fair', good: 'Good', strong: 'Strong' })[level.value] ?? '')
</script>

<style scoped>
.password-strength {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.strength-bar {
  display: flex;
  gap: 3px;
  flex: 1;
}

.strength-segment {
  height: 4px;
  flex: 1;
  border-radius: 2px;
  background-color: var(--bs-secondary-bg);
  transition: background-color 0.2s;
}

.filled-weak   { background-color: #dc3545; }
.filled-fair   { background-color: #fd7e14; }
.filled-good   { background-color: #ffc107; }
.filled-strong { background-color: #198754; }

.strength-label {
  position: relative;
  top: -6px;
  height: 0;
  overflow: visible;
  font-size: 0.67rem;
  font-weight: 500;
  width: 3.5rem;
  text-align: right;
}

.label-weak   { color: #dc3545; }
.label-fair   { color: #fd7e14; }
.label-good   { color: #ffc107; }
.label-strong { color: #198754; }
</style>
